module.exports = __webpack_public_path__ + "4a30fd94fbc34073f296bef5570156df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/leto-32.jpg
// module id = 1174
// module chunks = 0